//List of all isPass flag constants
export const ZERO = "ZERO";
export const NEGATIVE = "NEGATIVE";
export const DAY24HRS = "DAY24HRS";
export const EQUAL = "EQUAL";
export const OVERLAPPING = "OVERLAPPING";
export const POSITIVE = "POSITIVE";

//List of all action flag constants;
export const ADD = "ADD";
export const UPDATE = "UPDATE";

//List for all punchstatus flag;
export const CLOCKIN = "CLOCKIN";
export const CLOCKOUT = "CLOCKOUT";
export const MISSEDCLOCKIN = "MISSEDCLOCKIN";
export const MISSEDCLOCKOUT = "MISSEDCLOCKOUT";

export const categoryPunch = "punch";
export const categoryPTO = "pto";
export const MEAL = "Meal";
export const DELETED = "deleted";

export const login = {
  nameColor: "#1B75BC",// blue color
  dateTimeColor: "#C8C8C8",// grey color
  clockInColor: "#8DC13F",//green color
  clockOutColor: "#58595B",//dark grey color
  outColor: "#b00020",//red color
  bgColor: "#f3f5f7",//background color
  robotoRegular: "Roboto-Regular",//font style
};
